export default {
  details: 'details',
  vendors: 'vendors'
}
